import { useLazyGetNdasBySirenQuery } from '@common/services';
import { useAppDispatch } from '../../../hooks/store.hook';
import { setNdas } from '../../../stores/inscription.slice';

export function useLoadNdas() {
  const dispatch = useAppDispatch();

  const [getNdasBySiren] = useLazyGetNdasBySirenQuery();

  return {
    loadNdas: async (siren: string) => {
      const codes: string[] | null = await getNdasBySiren({ siren }).unwrap().catch(() => null);
      if (codes) dispatch(setNdas(codes));
    },
  };
}